import styled from "styled-components";
import { colors } from "../../../styles/colors";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(18, 34, 67, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  direction: rtl;
  animation: fadeIn 0.2s ease-out;
  overflow: visible;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const ModalContent = styled.div`
  background: ${colors.white};
  border-radius: 20px;
  padding: 32px;
  max-width: 600px;
  width: 100%;
  max-height: 85vh;
  overflow: visible;
  position: relative;
  box-shadow: 0 25px 50px -12px rgba(18, 34, 67, 0.25),
    0 0 0 1px rgba(18, 34, 67, 0.05);
  direction: rtl;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease-out;

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(20px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @media (max-width: 768px) {
    padding: 24px 20px;
    max-width: 100%;
    margin: 0 16px;
    border-radius: 16px;
    max-height: 90vh;
  }

  @media (max-width: 480px) {
    padding: 20px 16px;
    margin: 0 8px;
  }
`;

export const ModalTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: ${colors.darkBlue};
  font-family: "Noto Sans Hebrew", sans-serif;
  margin: 0 0 32px 0;
  text-align: center;
  direction: rtl;
  letter-spacing: -0.02em;

  @media (max-width: 768px) {
    font-size: 20px;
    margin-bottom: 24px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 10px;
  border-radius: 12px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${colors.lightGray};
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }

  img {
    width: 18px;
    height: 18px;
    object-fit: contain;
    opacity: 0.7;
    transition: opacity 0.2s ease;
  }

  &:hover img {
    opacity: 1;
  }

  @media (max-width: 768px) {
    top: 16px;
    right: 16px;
    padding: 8px;
  }
`;

export const FilterSection = styled.div`
  margin-bottom: 32px;
  direction: rtl;
  flex: 1;
  overflow: visible;
  padding-right: 8px;
  margin-right: -8px;

  @media (max-width: 768px) {
    margin-bottom: 24px;
  }
`;

export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  flex-wrap: nowrap;
  gap: 16px;
  direction: rtl;
  width: 100%;
  box-sizing: border-box;

  &.date-range-row {
    flex-direction: row;
    align-items: center;
    gap: 16px;
    margin-bottom: 20px;
  }

  @media (max-width: 768px) {
    flex-direction: row;
    align-items: center;
    gap: 12px;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin-bottom: 12px;

    &.date-range-row {
      flex-direction: row;
      gap: 12px;
      margin-bottom: 16px;
    }
  }

  @media (max-width: 480px) {
    gap: 8px;
    margin-bottom: 10px;

    &.date-range-row {
      flex-direction: row;
      gap: 8px;
      margin-bottom: 12px;
    }
  }
`;

export const FilterButton = styled.button`
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  color: ${colors.darkBlue};
  cursor: pointer;
  height: 36px;
  border-radius: 20px;
  background-color: ${colors.lightGray};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 18px;
  border: 2px solid transparent;
  outline: none;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 90px;
  gap: 8px;
  position: relative;
  direction: rtl;
  white-space: nowrap;
  max-width: 100%;
  box-sizing: border-box;
  flex-shrink: 1;
  font-family: "Noto Sans Hebrew", sans-serif;

  &.date-range-button {
    width: 100%;
    min-width: 120px;
    height: 36px;
    font-size: 14px;
    padding: 0 18px;
    border-radius: 18px;

    @media (max-width: 768px) {
      height: 30px;
      font-size: 13px;
      padding: 0 16px;
      border-radius: 15px;
    }

    @media (max-width: 480px) {
      height: 30px;
      font-size: 12px;
      padding: 0 14px;
      border-radius: 15px;
    }
  }

  &:hover {
    background-color: ${colors.blueGray};
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(18, 34, 67, 0.15);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(18, 34, 67, 0.1);
  }

  &.active {
    background-color: ${colors.blue};
    color: ${colors.white};
    border-color: ${colors.blue};
    box-shadow: 0 4px 16px rgba(0, 122, 255, 0.3);
    transform: translateY(-1px);
  }

  &.active:hover {
    background-color: ${colors.darkBlue};
    border-color: ${colors.darkBlue};
    box-shadow: 0 6px 20px rgba(0, 122, 255, 0.4);
  }

  img {
    width: 16px;
    height: 16px;
    object-fit: contain;
    flex-shrink: 0;
    transition: transform 0.2s ease;
  }

  &:hover img {
    transform: scale(1.1);
  }

  @media (max-width: 768px) {
    min-width: 80px;
    padding: 0 14px;
    font-size: 13px;
    height: 32px;
    border-radius: 18px;
  }

  @media (max-width: 480px) {
    min-width: 70px;
    padding: 0 12px;
    font-size: 12px;
    height: 30px;
    gap: 6px;

    img {
      width: 14px;
      height: 14px;
    }
  }
`;

export const FilterItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  flex: 1;
  direction: rtl;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;

  &.date-range-item {
    flex: 1;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    display: flex;
    align-items: center;
  }

  img {
    width: 16px;
    height: 16px;
    object-fit: contain;
  }

  .campaign-filter-container,
  .month-filter-container,
  .date-range-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    min-width: 0;
    max-width: 100%;

    .dropdown-icon {
      width: 12px;
      height: 12px;
      object-fit: contain;
      transition: transform 0.2s ease;
    }
  }

  .date-range-container {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  @media (max-width: 768px) {
    flex: 1;
    min-width: 0;
    max-width: 100%;

    &.date-range-item {
      flex: 1;
      width: 100%;
    }
  }
`;

export const FilterSectionDivider = styled.div`
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    ${colors.lightBlueGray},
    transparent
  );
  margin: 20px 0;
  width: 100%;

  @media (max-width: 768px) {
    margin: 16px 0;
  }
`;

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    gap: 12px;
    margin-bottom: 16px;
  }
`;

export const FilterGroupTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${colors.darkBlue};
  font-family: "Noto Sans Hebrew", sans-serif;
  margin: 0 0 8px 0;
  direction: rtl;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const DateRangeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: nowrap;
  flex: 1;
  min-width: 0;
  direction: rtl;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .date-input-container {
    position: relative;
    display: inline-block;
    flex: 1;
    min-width: 0;
  }

  .date-placeholder {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    font-size: 14px;
    color: ${colors.darkBlue};
    font-family: "Noto Sans Hebrew", sans-serif;
    pointer-events: none;
    z-index: 3;
    transition: opacity 0.2s ease;
  }

  .date-input-container:focus-within .date-placeholder {
    opacity: 0;
  }

  .date-display-text {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    font-size: 14px;
    color: ${colors.darkBlue};
    font-family: "Noto Sans Hebrew", sans-serif;
    pointer-events: none;
    z-index: 3;
    white-space: nowrap;
    max-width: calc(100% - 24px);
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .date-input-container:has(.active) .date-display-text {
    color: ${colors.white};
  }
`;

export const DateInput = styled.input`
  font-size: 14px;
  line-height: 14px;
  color: transparent;
  cursor: pointer;
  height: 36px;
  border-radius: 20px;
  background-color: ${colors.lightGray};
  border: 2px solid transparent;
  padding: 0 16px;
  font-family: "Noto Sans Hebrew", sans-serif;
  width: 100%;
  position: relative;
  z-index: 1;
  direction: rtl;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  &.active {
    background-color: ${colors.blue};
    color: ${colors.white};
    border-color: ${colors.blue};
  }

  &.hidden-date-input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
    width: 0;
    height: 0;
    overflow: hidden;
  }

  &.date-input {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    cursor: pointer;
    z-index: 2;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    border: none;
    background: transparent;
  }

  &:focus {
    outline: 2px solid ${colors.blue};
    outline-offset: 2px;
  }

  @media (max-width: 768px) {
    height: 32px;
    padding: 0 14px;
    border-radius: 18px;
  }

  @media (max-width: 480px) {
    height: 30px;
    padding: 0 12px;
    border-radius: 16px;
  }

  /* Hide the default date input styling when empty */
  &::-webkit-datetime-edit {
    color: transparent;
    opacity: 0;
  }

  &::-webkit-datetime-edit-text {
    color: transparent;
    opacity: 0;
  }

  &::-webkit-datetime-edit-month-field {
    color: transparent;
    opacity: 0;
  }

  &::-webkit-datetime-edit-day-field {
    color: transparent;
    opacity: 0;
  }

  &::-webkit-datetime-edit-year-field {
    color: transparent;
    opacity: 0;
  }

  &::-webkit-datetime-edit-fields-wrapper {
    opacity: 0;
  }

  &::-webkit-calendar-picker-indicator {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    margin: 0;
    z-index: 2;
  }

  /* Keep date input hidden even when selected - we show custom Hebrew text instead */
  &:not([value=""]) {
    color: transparent;

    &.active {
      color: transparent;
    }

    &::-webkit-datetime-edit {
      color: transparent;
      opacity: 0;
    }

    &::-webkit-datetime-edit-text {
      color: transparent;
      opacity: 0;
    }

    &::-webkit-datetime-edit-month-field {
      color: transparent;
      opacity: 0;
    }

    &::-webkit-datetime-edit-day-field {
      color: transparent;
      opacity: 0;
    }

    &::-webkit-datetime-edit-year-field {
      color: transparent;
      opacity: 0;
    }

    &::-webkit-datetime-edit-fields-wrapper {
      opacity: 0;
    }
  }
`;

export const SourceDropdown = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background-color: ${colors.white};
  border: 1px solid ${colors.lightBlueGray};
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(18, 34, 67, 0.15),
    0 0 0 1px rgba(18, 34, 67, 0.05);
  z-index: 1001;
  min-width: 200px;
  max-width: 300px;
  max-height: 240px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 8px;
  direction: rtl;
  animation: dropdownSlide 0.2s ease-out;
  backdrop-filter: blur(8px);

  @keyframes dropdownSlide {
    from {
      opacity: 0;
      transform: translateY(-8px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @media (max-width: 768px) {
    max-width: calc(100vw - 40px);
    right: 0;
    left: auto;
    transform: none;
    min-width: 180px;
    border-radius: 10px;
  }

  &::-webkit-scrollbar {
    width: 6px;

    &-track {
      background: transparent;
      border-radius: 3px;
    }

    &-thumb {
      background: ${colors.blueGray};
      border-radius: 3px;
    }
  }
`;

export const MonthDropdown = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background-color: ${colors.white};
  border: 1px solid ${colors.lightBlueGray};
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(18, 34, 67, 0.15),
    0 0 0 1px rgba(18, 34, 67, 0.05);
  z-index: 1001;
  min-width: 200px;
  max-width: 300px;
  max-height: 240px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 8px;
  direction: rtl;
  animation: dropdownSlide 0.2s ease-out;
  backdrop-filter: blur(8px);

  @keyframes dropdownSlide {
    from {
      opacity: 0;
      transform: translateY(-8px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @media (max-width: 768px) {
    max-width: calc(100vw - 40px);
    left: 0;
    right: auto;
    transform: none;
    min-width: 180px;
    border-radius: 10px;
  }

  &::-webkit-scrollbar {
    width: 6px;

    &-track {
      background: transparent;
      border-radius: 3px;
    }

    &-thumb {
      background: ${colors.blueGray};
      border-radius: 3px;
    }
  }
`;

export const CampaignOption = styled.div`
  padding: 12px 18px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 14px;
  font-weight: 500;
  color: ${colors.darkBlue};
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  direction: rtl;
  font-family: "Noto Sans Hebrew", sans-serif;
  position: relative;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 10px 14px;
    font-size: 13px;
  }

  &:hover {
    background-color: ${colors.lightBlueGrayBackground};
    transform: translateX(-2px);
  }

  &.selected {
    background-color: ${colors.lightBlueGrayBackground};
    font-weight: 600;
    border-right: 3px solid ${colors.blue};
    color: ${colors.blue};
  }

  &.clear-option {
    color: ${colors.blueGray};
    font-style: italic;
    border-bottom: 1px solid ${colors.lightBlueGray};
    font-weight: 400;

    &:hover {
      background-color: ${colors.lightGray};
      color: ${colors.darkBlue};
      font-style: normal;
    }
  }

  &:first-child {
    border-radius: 12px 12px 0 0;
  }

  &:last-child {
    border-radius: 0 0 12px 12px;
  }

  &:only-child {
    border-radius: 12px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: auto;
  padding-top: 24px;
  direction: rtl;
  flex-shrink: 0;

  @media (max-width: 768px) {
    flex-direction: row;
    gap: 12px;
    justify-content: center;
    padding-top: 20px;
  }

  @media (max-width: 480px) {
    gap: 10px;
    padding-top: 16px;
  }
`;

export const ApplyButton = styled.button`
  background: ${colors.blue};
  border: 2px solid ${colors.blue};
  color: ${colors.white};
  padding: 0 24px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  font-family: "Noto Sans Hebrew", sans-serif;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 100px;
  order: 2;
  direction: rtl;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );
    transition: left 0.5s;
  }

  &:hover {
    background: ${colors.darkBlue};
    border-color: ${colors.darkBlue};
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 122, 255, 0.4);
  }

  &:hover::before {
    left: 100%;
  }

  &:active {
    transform: translateY(-1px);
    box-shadow: 0 4px 15px rgba(0, 122, 255, 0.3);
  }

  &:focus {
    outline: 2px solid ${colors.blue};
    outline-offset: 2px;
  }

  @media (max-width: 768px) {
    min-width: 90px;
    height: 36px;
    padding: 0 20px;
    font-size: 13px;
  }

  @media (max-width: 480px) {
    min-width: 80px;
    height: 32px;
    padding: 0 16px;
    font-size: 12px;
  }
`;

export const CancelButton = styled.button`
  background: ${colors.lightGray};
  border: 2px solid ${colors.lightGray};
  color: ${colors.darkBlue};
  padding: 0 24px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  font-family: "Noto Sans Hebrew", sans-serif;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 100px;
  order: 1;
  direction: rtl;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${colors.blueGray};
    border-color: ${colors.blueGray};
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(126, 138, 173, 0.3);
  }

  &:active {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(126, 138, 173, 0.2);
  }

  &:focus {
    outline: 2px solid ${colors.blue};
    outline-offset: 2px;
  }

  @media (max-width: 768px) {
    min-width: 90px;
    height: 36px;
    padding: 0 20px;
    font-size: 13px;
  }

  @media (max-width: 480px) {
    min-width: 80px;
    height: 32px;
    padding: 0 16px;
    font-size: 12px;
  }
`;
